"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const annualCargoDefinition_1 = __importDefault(require("./annualCargoDefinition"));
const flatCharge_1 = __importDefault(require("./flatCharge"));
class AnnualCargoRates {
    constructor(data, ranges, dataFlat) {
        this.validationsHighlight = [];
        this.usedDataToCalc = {};
        this.applicationFields = data.map((cargoRange) => annualCargoDefinition_1.default.fromObj(cargoRange, ranges));
        this.flatCharges = dataFlat.map((charge) => flatCharge_1.default.fromObj(charge));
    }
    calculatePercentageTarget(amountTransitPremium, amountTargetPremium) {
        if (!amountTargetPremium) {
            return amountTransitPremium;
        }
        const differenceTarget = (amountTransitPremium / amountTargetPremium) * 100;
        this.usedDataToCalc.diffWithTargetPremium = differenceTarget;
        if (differenceTarget < 80) {
            this.usedDataToCalc.targetPremiumRuleApplied = true;
            return amountTargetPremium * 0.8;
        }
        return amountTransitPremium;
    }
    validationAnnualSalesVsAnnualShipment(annualShipment, annualSales) {
        const percentage = 60;
        this.validationsHighlight = [];
        let annualShipmentSet = 0;
        let annualSalesSet = 0;
        let differenceValue = 0;
        if (annualShipment) {
            annualShipmentSet = annualShipment;
        }
        if (annualSales) {
            annualSalesSet = annualSales.value || 0;
        }
        if (annualShipment && (annualSales === null || annualSales === void 0 ? void 0 : annualSales.value)) {
            differenceValue =
                (Math.abs(annualSalesSet - annualShipmentSet) /
                    ((annualSalesSet + annualShipmentSet) / 2)) *
                    100;
        }
        this.usedDataToCalc.diffAnnualSalesWithAnnualShipment = differenceValue;
        if (differenceValue >= percentage) {
            this.validationsHighlight.push({
                name: "difference AnnualSales AnnualShipment",
                value: `${percentage}% difference between Annual Sales and Annual Shipment values.`
            });
            this.premiumFees = {
                minimumRuleApplied: false,
                transitPremium: 0,
                warPremium: 0,
                toBeDefined: true
            };
        }
    }
    validation200M(annualShipment, annualSales) {
        const twoHundredMillion = 200000000;
        if ((annualShipment && annualShipment >= twoHundredMillion) ||
            ((annualSales === null || annualSales === void 0 ? void 0 : annualSales.value) && (annualSales === null || annualSales === void 0 ? void 0 : annualSales.value) >= twoHundredMillion)) {
            this.validationsHighlight.push({
                name: "validation 200M",
                value: "Value greater than or equal to USD 200M."
            });
            this.premiumFees = {
                minimumRuleApplied: false,
                transitPremium: 0,
                warPremium: 0,
                toBeDefined: true
            };
        }
    }
    validationNoRate() {
        this.validationsHighlight.push({
            name: "no rate",
            value: "No rate defined for the commodity selected."
        });
    }
    getValidationsHighlight(annualShipment, annualSales, toBeDefined) {
        this.validationsHighlight = [];
        if (toBeDefined) {
            this.validationNoRate();
        }
        else {
            this.validationAnnualSalesVsAnnualShipment(annualShipment, annualSales);
            this.validation200M(annualShipment, annualSales);
        }
        return this.validationsHighlight;
    }
    calculatePremiumFees(commoditiesId, amount, amountTarget = 0) {
        const customRates = [];
        commoditiesId.forEach((commodity) => {
            const customRate = this.applicationFields.find((rate) => rate.commodityIds.includes(commodity));
            const rate = customRate === null || customRate === void 0 ? void 0 : customRate.ranges.find((range) => range.from !== undefined &&
                amount >= range.from &&
                range.to !== undefined &&
                amount <= range.to);
            if (rate) {
                customRates.push(rate);
            }
        });
        this.usedDataToCalc.baseAmountToCalculate = amount;
        if (customRates.length > 0) {
            const ratePercentage = customRates
                .map((r) => r.percentage)
                .sort((a, b) => b - a)[0];
            const rateMin = customRates.map((r) => r.min).sort((a, b) => b - a)[0];
            this.usedDataToCalc.percentage = ratePercentage;
            this.usedDataToCalc.minimum = rateMin;
            let calculatedTransitPremium = (amount * ratePercentage) / 100;
            calculatedTransitPremium = this.calculatePercentageTarget(calculatedTransitPremium, amountTarget);
            const warPremium = calculatedTransitPremium * 0.1;
            this.premiumFees = {
                minimumRuleApplied: false,
                transitPremium: calculatedTransitPremium,
                toBeDefined: false,
                warPremium
            };
            if (calculatedTransitPremium < rateMin) {
                this.premiumFees.transitPremium = this.calculatePercentageTarget(rateMin, amountTarget);
                this.premiumFees.minimumRuleApplied = true;
                this.premiumFees.warPremium = this.premiumFees.transitPremium * 0.1;
            }
        }
        else {
            this.premiumFees = {
                minimumRuleApplied: false,
                transitPremium: 0,
                warPremium: 0,
                toBeDefined: true
            };
        }
        return this.premiumFees;
    }
    calculateFlatCharges(coverageForExhibition, exhibitionCoverage, salespersonsSamplesCoverage) {
        this.flatFees = [];
        let exhibitionCoverageSet = 0;
        let salespersonsSamplesCoverageSet = 0;
        if (exhibitionCoverage !== "N/A") {
            exhibitionCoverageSet = exhibitionCoverage;
        }
        if (salespersonsSamplesCoverage !== "N/A") {
            salespersonsSamplesCoverageSet = salespersonsSamplesCoverage;
        }
        if (coverageForExhibition) {
            const chargesExhibition = this.flatCharges.find((charge) => charge.type === "exhibitionCoverage");
            const feesByExhibition = chargesExhibition.charges.find((charge) => charge.amount === exhibitionCoverageSet);
            if (feesByExhibition && feesByExhibition.fees) {
                this.flatFees.push(...(feesByExhibition.fees));
            }
            const chargesSalesperson = this.flatCharges.find((charge) => charge.type === "salespersonSamples");
            const feesBySalesperson = chargesSalesperson.charges.find((charge) => charge.amount === salespersonsSamplesCoverageSet).fees;
            this.flatFees.push(...feesBySalesperson);
        }
        return this.flatFees;
    }
    getTotalOtherPremiumCharges() {
        var _a, _b;
        let totalOtherChanges = 0;
        if (this.flatFees && ((_a = this.flatFees) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            const totalFlatFees = (_b = this.flatFees) === null || _b === void 0 ? void 0 : _b.reduce((sum, fee) => sum + fee.value, 0);
            totalOtherChanges += totalFlatFees;
        }
        return totalOtherChanges;
    }
    getTotalPremium() {
        var _a, _b;
        return ((((_a = this.premiumFees) === null || _a === void 0 ? void 0 : _a.transitPremium) || 0) +
            (((_b = this.premiumFees) === null || _b === void 0 ? void 0 : _b.warPremium) || 0) +
            this.getTotalOtherPremiumCharges());
    }
}
exports.default = AnnualCargoRates;
//# sourceMappingURL=annualCargoRates.class.js.map